module.exports = __webpack_public_path__ + "static/media/benefits-internacional.d9d6f75a.png";